<template>
  <div class="switch-container">
    <div class="switch">
      <span class="switch-label">app登录功能</span>
      <input type="checkbox" id="switch1" v-model="isChecked1" @change="handleSwitchChange('1', isChecked1,)">
      <label for="switch1" class="slider"></label>

    </div>
    <div class="switch">
      <span class="switch-label">app中继功能</span>
      <input type="checkbox" id="switch2" v-model="isChecked2" @change="handleSwitchChange('2', isChecked2,)">
      <label for="switch2" class="slider"></label>

    </div>
    <!-- <div class="switch">
      <span class="switch-label">专用菜单</span>
      <input type="checkbox" id="switch3" v-model="isChecked3" @change="handleSwitchChange('3', isChecked3,)">
      <label for="switch3" class="slider"></label>

    </div> -->
    
  </div>
</template>

<script>
import { device_app_check, device_app_setting } from "@/api/api";
export default {
  data() {
    return {
      isChecked1: false,
      isChecked2: false,
      isChecked3: false,
    };
  },
  mounted() {
    device_app_check().then((res) => {
      this.isChecked1 = res.code1;
      this.isChecked2 = res.code2;
      this.isChecked3 = res.code3;
      if (res.code1 == 1) {
        this.isChecked1 = true;
      } else {
        this.isChecked1 = false;
      }
      if (res.code2 == 1) {
        this.isChecked2 = true;
      } else {
        this.isChecked2 = false;
      }
      if (res.code3 == 1) {
        this.isChecked3 = true;
      } else {
        this.isChecked3 = false;
      }
    });
  },
  methods: {
    async handleSwitchChange(type, value) {
      console.log(type);
      device_app_setting({ type }).then((res) => {
        console.log(res);
        switch (type) {
          case 1:
            if (res.code1 == 1) {
              this.isChecked1 = true;
            } else {
              this.isChecked1 = false;
            }

            break;

          case 2:
            if (res.code2 == 1) {
              this.isChecked2 = true;
            } else {
              this.isChecked2 = false;
            }
            break;
          case 3:
            if (res.code3 == 1) {
              this.isChecked3 = true;
            } else {
              this.isChecked3 = false;
            }
            break;

          default:
            break;
        }
      });
    },
  },
};
</script>

<style scoped>
.switch-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.switch {
  display: flex;
  align-items: center;
  gap: 10px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  background-color: #ccc;
  border-radius: 34px;
  cursor: pointer;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  border-radius: 50%;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}

input:checked+.slider {
  background-color: #2196f3;
}

input:checked+.slider:before {
  transform: translateX(26px);
}

.switch-label {
  float: left;
  height: 40px;
  line-height: 40px;
  width: 120px;
  font-size: 20px;
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: bold;
  color: #73879c;
}
</style>
